export default __webpack_public_path__ + "static/media/soleil_regular.1afd03b6.woff2";